import { usePageMeta } from "@/components/pepmuse/usePageMeta";
import { Reveal, Eyebrow } from "@/components/pepmuse/Reveal";
import { ARTICLES } from "@/data/articles";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";

export default function Resources() {
  usePageMeta(
    "Resources — PepMuse",
    "Guides for starting and launching a research-use-only peptide brand: wholesale supply, white-label vials, 3PL fulfillment, compliance, and a 30-day launch plan."
  );

  return (
    <section data-testid="resources-page" className="pb-24 pt-[120px] sm:pt-[150px]">
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8">
        <Reveal>
          <Eyebrow testId="resources-eyebrow">Resources</Eyebrow>
          <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-paper sm:text-5xl">
            Start an RUO peptide brand,
            <br />
            eyes open.
          </h1>
          <p className="mt-4 max-w-xl text-base text-paper/60">
            Practical guides on what it actually takes — supply, white-label vials, compliance, fulfillment, and a
            realistic launch plan.
          </p>
        </Reveal>

        <div data-testid="resources-list" className="mt-12 space-y-4">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.05}>
              <Link
                to={`/resources/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group block rounded-2xl border border-white/[0.08] bg-card p-7 transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 hover:border-lilac/40 hover:bg-white/[0.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac"
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="min-w-0">
                    <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-paper/35">
                      <BookOpen className="h-3.5 w-3.5 text-lilac" aria-hidden="true" />
                      Guide · {a.readMinutes} min read
                    </p>
                    <h2 className="mt-2.5 font-display text-xl font-extrabold tracking-tight text-paper transition-colors group-hover:text-lilac sm:text-2xl">
                      {a.title}
                    </h2>
                    <p className="mt-2.5 text-sm leading-relaxed text-paper/55">{a.description}</p>
                  </div>
                  <ArrowRight
                    className="mt-2 h-5 w-5 shrink-0 text-paper/30 transition-[transform,color] duration-200 group-hover:translate-x-1 group-hover:text-lilac"
                    aria-hidden="true"
                  />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
